import DashboardMap from "./dashboardMap";
export default DashboardMap;
